import React from 'react';
import NavigationBar from '../Shared/NavigationBar/NavigationBar';

const AboutPage = () => {
    return (
        <div>
            <NavigationBar></NavigationBar>
            <h1>This is About Page</h1>
        </div>
    );
};

export default AboutPage;